'use strict';

window.CFC = window.CFC || {};

window.CFC.Common = (function($) {
  function init() {
    initYouTubeWrappers();
    initGForms();
    suppressAnimationsOnCachedLoad();
    window.Plaintext.DescriptionExpander.init();
    document.querySelectorAll('.styledDropdown').forEach(window.Plaintext.StyledDropdown.init);
  }
  
  function initYouTubeWrappers() {
    $('.media__wrap[data-youtube-id]').on('click', function() {
      var $this = $(this);
      var youtubeId = $this.attr('data-youtube-id');
      var targetId = $this.find('.media__video').attr('id');
      
      if (!YT) { return; }

      var playerOptions = getYTPlayerOptions(youtubeId);
      var player = new YT.Player(targetId, playerOptions);
    })
  }
  
  function getYTPlayerOptions(videoId) {
    return {
      videoId: videoId,
      hl: window.CFC_Vars.lang,
      events: {
        'onReady': function(e) { e.target.playVideo(); }
      },

      playerVars: {
        cc_lang_pref: window.CFC_Vars.lang,
        autoplay: 1,
        iv_load_policy: 3,
        modestbranding: 1,
        enablejsapi: 1,
        rel: 0,
      }        
    };
  }
  
  function initGForms() {
    if (!$('.gform_wrapper').length) { return; }
    
    // Move inside-input labels outside when they have values.  
    var fnToggleOutsideLabelClass = function() {
      var $self = $(this);

      window.setTimeout(function() {
        var val = $self.val();
        $self.closest('.gfield').find('.gfield_label').toggleClass('gfield_label--outside', !!val);
      }, 0);
    };
    
    var fnSetOutsideLabelClassOnFocus = function() { $(this).closest('.gfield').find('.gfield_label').addClass('gfield_label--outside'); };
    var fnRemoveErrorOnEdit = function() { $(this).closest('.gfield').removeClass('gfield_error').find('.validation_message').remove(); };
    
    var fnInitOutsideLabelClasses = function() { 
      var $inlineLabelInputs = $('.gfield').find('input, textarea, select');

      $inlineLabelInputs.each(fnToggleOutsideLabelClass);
      $inlineLabelInputs.off('focus', fnSetOutsideLabelClassOnFocus).on('focus', fnSetOutsideLabelClassOnFocus);
      $inlineLabelInputs.off('blur', fnToggleOutsideLabelClass).on('blur', fnToggleOutsideLabelClass);
      $inlineLabelInputs.off('keydown', fnToggleOutsideLabelClass).on('keydown', fnToggleOutsideLabelClass);
      $inlineLabelInputs.off('keydown, change', fnRemoveErrorOnEdit).on('keydown, change', fnRemoveErrorOnEdit);
    };
    
    fnInitOutsideLabelClasses();
    $(document).on("gform_post_render", fnInitOutsideLabelClasses);
  }
  
  function _suppressAnimationsPageShowHandler(event) {
    if (event.persisted) {
      $('body').addClass('no-animations');
      window.setTimeout(function() { $('body').removeClass('no-animations'); }, 10);
    }
  }
  
  function suppressAnimationsOnCachedLoad() {
    window.removeEventListener('pageshow', _suppressAnimationsPageShowHandler);
    window.addEventListener('pageshow', _suppressAnimationsPageShowHandler);
  }
  
  function isFrench() {
    return document.body.classList.contains('lang--fr');
  }
  
  function enFr(en, fr) {
    return isFrench() ? fr : en;
  }
  
  function createModal(contentsNode, focusAfterClose, focusFirst, additionalClasses) {
    aria.closeCurrentDialog();
    
    const dialogEl = document.createElement('div');
    dialogEl.setAttribute('role', 'dialog');
    dialogEl.setAttribute('class', 'dialog ');
    dialogEl.appendChild(contentsNode);

    document.body.append(dialogEl);

    const dialog = new aria.Dialog(dialogEl, focusAfterClose, focusFirst);
    additionalClasses = Array.isArray(additionalClasses) ? additionalClasses : (additionalClasses ? [ additionalClasses ] : []);
    additionalClasses.forEach(c => dialogEl.classList.add(c));

    document.addEventListener('dialog.closed', () => {
      dialogEl.remove();
    });

    window.CFC.Forms.setInnerLabelHandlers();
    return dialog;
  }
  
  function getModalCloseButtonHtml() {
    return `<button type='button' class='dialog-close dialog-close--hovering' aria-label='${ CFC.__esc('general.close') }'>
        <img alt="" src="${ window.CFC_Vars.themeRoot }/assets/img/icon/close.svg" />
      </button>`;
  }
    
  function getModalCloseButtonNode() {
    return $(getModalCloseButtonHtml())[0];
  }
    
  $(init);
  
  return {
    enFr,
    isFrench,
    createModal,
    getModalCloseButtonHtml,
    getModalCloseButtonNode,
    getYTPlayerOptions
  };
})(jQuery);

CFC.__ = function(handle) {
  return window.cfctx[handle];
}

CFC.__esc = function(handle) { 
  return _.escape(CFC.__(handle));
}